
const initialState = {
    matterport: '',
    matterportType: '',
};

const matterport = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default matterport;
